'use client';
import { useEffect, useState } from 'react';

import { OnBoardingTipItem } from '../onBoardingTipItem/onBoardingTipItem';
import useUserContext from '@susu/custom-made/providers/hooks/useUserContext';

export const OnBoardingTips = () => {
  const visitedStorageName = 'cm_visited_products_tips';
  const { product } = useUserContext();
  const [isShown, setIsShown] = useState<boolean>(false);

  const saveStorage = () => {
    const currentProduct = product as string;
    const visitedProductStorage = localStorage.getItem(visitedStorageName);
    let visitedProductArray = [currentProduct];
    if (visitedProductStorage) {
      visitedProductArray = [...visitedProductStorage.split(','), ...visitedProductArray];
    }
    localStorage.setItem(visitedStorageName, visitedProductArray.join(','));
  };

  const checkStorage = () => {
    const currentProduct = product as string;
    const visitedProductStorage = localStorage.getItem(visitedStorageName);
    return visitedProductStorage && visitedProductStorage.split(',').indexOf(currentProduct) >= 0;
  };

  useEffect(() => {
    if (!checkStorage()) {
      setTimeout(() => {
        setIsShown(true);
      }, 1000);
    }
  }, []);

  return (
    <>
      <OnBoardingTipItem
        isShown={isShown}
        hideTooltip={() => {
          setIsShown(false);
        }}
        saveStorage={saveStorage}
      ></OnBoardingTipItem>
    </>
  );
};
